import { GlobalState } from "@/Reducers/interface";
import { useSelector } from "react-redux";
import { checkUseAccessLevel } from "@/Hooks/utils";

export const useAccessLevel = (id: string | null | undefined): boolean => {
	const userData = useSelector((state: GlobalState) => state.user.userData);
	return checkUseAccessLevel(userData)(id);
};
